export default "__VITE_ASSET__DJEBkZ6l__"